import React from 'react';
import { CSVLink } from 'react-csv';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// external libraries
import moment from 'moment';

const { FormatMoney } = require('format-money-js');

const fmDecimal = new FormatMoney({
  decimals: 2,
});

const CancellationsCSV = ({ data }) => {
  const csvData = data.map((cancellation) => ({
    date: moment(cancellation?.created_date).format('DD-MM-YY'),
    dateUpdate: moment(cancellation?.updated_date).format('DD-MM-YY'),
    legalName: cancellation?.legal_name?.toUpperCase(),
    reasonUser: cancellation?.reason?.toUpperCase(),
    author: cancellation?.author?.toUpperCase(),
    cost: fmDecimal.from(cancellation?.total, { symbol: '$' }),
    amount: fmDecimal.from(cancellation?.refunded_amount, { symbol: '$' }),
    stateRequested: cancellation?.requested ? 'SI' : '',
    stateCanceled: cancellation?.canceled ? 'SI' : '',
    stateRefunded: cancellation?.refunded ? 'SI' : '',
    stateConsumed: cancellation?.consumed ? 'SI' : '',
    ...cancellation,
  }));

  const headers = [
    { label: 'CRM ID', key: 'api_user' },
    { label: 'Usuario', key: 'legalName' },
    { label: 'Fecha Solicitud', key: 'date' },
    { label: 'Servicio', key: 'shipping_code' },
    { label: 'ID Envío', key: 'shipping_id' },
    { label: 'Proveedor', key: 'provider' },
    { label: 'Costo guía', key: 'cost' },
    { label: 'Solicitada', key: 'stateRequested' },
    { label: 'Cancelada', key: 'stateCanceled' },
    { label: 'Reembolsada', key: 'stateRefunded' },
    { label: 'Monto reembolsado', key: 'amount' },
    { label: 'Utilizada', key: 'stateConsumed' },
    { label: 'Autor', key: 'author' },
    { label: 'Fecha actualización', key: 'dateUpdate' },
    { label: 'Motivo', key: 'reasonUser' },
  ];
  return (
    <CSVLink data={csvData} headers={headers} className="btn btn-primary" filename="Cancelaciones.csv" style={{ height: '36px' }} target="_blank">
      <span>
        <CsLineIcons icon="download" size="15" className="mb-1" /> Excel{' '}
      </span>
    </CSVLink>
  );
};
export default CancellationsCSV;
